module.exports = __webpack_public_path__ + "img/hero-robot.76b09dcd.png";